import { jsx } from "react/jsx-runtime";
import { css } from "@/styled-system/css";
import PropertySearch from "@zillow/property-search";
import ErrorBox from "./ErrorBox.esm.js";
import { PROPERTY_SEARCH_CONFIG_VALUES, sendInteractionSubmitEvent, FSBO_POSTING_URL_PATH } from "./FSBOPropertySearch.utils.esm.js";
import SearchInputWithButton, { SearchAdornment, searchFieldStyles } from "./SearchInputWithButton.esm.js";
import { useBlockEnvironment } from "../../contexts/BlockEnvironment/BlockEnvironmentProvider.esm.js";
const FSBOPropertySearch = ({
  id
}) => {
  var _a;
  const {
    environment = "prod"
  } = useBlockEnvironment();
  const buildResultsUrl = (address, latitude, longitude) => {
    var _a2;
    const encodedAddress = encodeURI(address) + `&cid=${Date.now()}&claimType=Ownership&latitude=${latitude}&listingType=ForSale&longitude=${longitude}`;
    const baseUrl = ((_a2 = PROPERTY_SEARCH_CONFIG_VALUES[environment]) == null ? void 0 : _a2["origin"]) || PROPERTY_SEARCH_CONFIG_VALUES.test.origin;
    return baseUrl + FSBO_POSTING_URL_PATH + encodedAddress;
  };
  const handleAddressSelect = (params) => {
    if (params == null ? void 0 : params.address) {
      const redirectUrl = buildResultsUrl(params.address, params.lat, params.lng);
      sendInteractionSubmitEvent(redirectUrl, id);
      window.open(redirectUrl, "_blank");
      return redirectUrl;
    }
    console.error("No results found for search");
  };
  return /* @__PURE__ */ jsx("div", { id: id || "", className: css(searchFieldStyles), children: /* @__PURE__ */ jsx(PropertySearch, { renderInput: SearchInputWithButton, renderAdornment: SearchAdornment, addressAutocompleteUrl: ((_a = PROPERTY_SEARCH_CONFIG_VALUES[environment]) == null ? void 0 : _a["addressAutocompleteURL"]) || PROPERTY_SEARCH_CONFIG_VALUES.test.addressAutocompleteURL, renderEmptyState: null, onSubmit: handleAddressSelect, renderError: ErrorBox }) });
};
export {
  FSBOPropertySearch as default
};
